var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Boxing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Boxing",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_boxing_3705155_000000",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7 30.826206 3.1836595 27 2 28.1836595 5.82620601 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.266864576,29.1954462 C-0.0889548586,29.5512244 -0.0889548586,30.1363019 0.266864576,30.4942529 L11.4966541,41.7331663 C11.8524735,42.0889446 12.4376188,42.0889446 12.7956112,41.7331663 L18,36.5293804 L11.7345841,30.2646902 L5.46038845,24 L4.47223282,24.9880412 L9.29294853,29.7974446 C9.64876796,30.1532228 9.64876796,30.7383003 9.29294853,31.0962513 L6.7143496,33.6659923 C6.53215429,33.8481665 6.302801,33.9403263 6.06487103,33.9403263 C5.82694656,33.9403263 5.59759326,33.8481665 5.41539247,33.6659923 L0.605431893,28.8565889 L0.266864576,29.1954462 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6081421,13.725399 C41.5369363,13.5976986 35.3984783,3.00941904 26.1392057,0.0955965562 C24.1642517,-0.521602044 21.6447859,1.9748704 19.6067809,3.99035509 L19.1858191,4.39898764 L19.1858191,4.40750082 C15.1207465,8.4022926 12.0904391,13.7335852 12.0545172,13.7869799 C11.8932547,14.0785583 11.5895752,14.2403059 11.2858957,14.2403059 C11.1330078,14.2403059 10.9822162,14.2041251 10.8398047,14.1232518 C10.4104682,13.8699868 10.2596927,13.3144863 10.5088996,12.8781757 C10.6345619,12.6696042 13.342548,7.90222989 17.1919819,3.8604726 C15.5835385,2.87081905 13.6085845,2.76228625 12.0190135,3.6433852 C6.67640788,6.62084539 5.7739639,18.6712558 6.0420378,22.9940433 L18.8490003,36 C19.0898487,35.8637892 19.3851481,35.6999112 19.6971862,35.5275173 C23.6638221,33.3396441 32.9480791,28.2080911 37.7021016,23.4772158 C43.7005232,17.5395125 41.6980648,13.8787097 41.6080456,13.7256087 L41.6081421,13.725399 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default ForwardRef;